import { render, staticRenderFns } from "./YearTemplate.vue?vue&type=template&id=662d6be6&scoped=true"
import script from "./YearTemplate.ts?vue&type=script&lang=ts&external"
export * from "./YearTemplate.ts?vue&type=script&lang=ts&external"
import style0 from "./YearTemplate.vue?vue&type=style&index=0&id=662d6be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d6be6",
  null
  
)

export default component.exports